var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "300px",
    width: "300px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "10 10 80 80",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,37.7h0.8v41.5c0,5.5,4.5,10,10,10h30.4c5.5,0,10-4.5,10-10V37.7H76c2.8,0,5-2.2,5-5v-8.2c0-2.8-2.2-5-5-5H63.6v-3.1   c0-3-2.5-5.5-5.5-5.5H41.9c-3,0-5.5,2.5-5.5,5.5v3.1H24c-2.8,0-5,2.2-5,5v8.2C19,35.4,21.3,37.7,24,37.7z M71.2,79.2   c0,3.3-2.7,6-6,6H34.8c-3.3,0-6-2.7-6-6V37.7h42.4V79.2z M40.4,16.4c0-0.8,0.7-1.5,1.5-1.5h16.1c0.8,0,1.5,0.7,1.5,1.5v3.1H40.4   V16.4z M23,24.5c0-0.6,0.4-1,1-1H76c0.6,0,1,0.4,1,1v8.2c0,0.6-0.4,1-1,1H24c-0.6,0-1-0.4-1-1V24.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.3,
    y: 46.3,
    width: 4,
    height: 29.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 46.3,
    width: 4,
    height: 29.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.7,
    y: 46.3,
    width: 4,
    height: 29.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.595d9710848e24f8e6640df56878ca59.svg";
export { ForwardRef as ReactComponent };